window.addEventListener("load", function() { // Ready function
    const fadeElements = document.querySelectorAll('.anm-fade-in')

    fadeElements.forEach((element, ind) => {
        setTimeout(() => {
            element.classList.add('anm-done')
        }, 400);
    });


    if(document.getElementById('wrapper-navbar')) {
        var wrapperNavbar = document.getElementById('wrapper-navbar')
        var mainNav = document.getElementById('main-nav')
        // alert('cè!! ' + wrapperNavbar.offsetHeight)
    } else {
        var wrapperNavbar = {offsetHeight: 0}
        var mainNav = {offsetHeight: 0}
        // alert('non cè!!')
    }

    /** Min height: (100vh - menu height) */
    let hClass = document.getElementsByClassName("min-h-100js")

    function nl_resize_vh() {
        if(hClass.length) {
            for (const element of hClass) {
                let hh =  (window.innerHeight - mainNav.offsetHeight)
                element.style.minHeight = hh + 'px'

                setTimeout(() => {
                    element.style.opacity = '1'
                }, 100);
             }
        }
    }
    nl_resize_vh()

    if(document.getElementById('gallery')) {
        let gallery = document.getElementById('gallery')
        gallery.style.minHeight = gallery.offsetHeight + 'px'
    }


    /** Set NavBar Height */
    function setWrapperNavbarHeight() {
        if(mainNav.offsetHeight != 0) {
            // let mainNav = document.getElementById('main-nav')
            wrapperNavbar.style.height = mainNav.offsetHeight + 'px'
        }
    }
    setWrapperNavbarHeight()

    /** On Window resize */
    window.addEventListener('resize', function (event) { /** Windows resize *** */
        if(document.getElementById('wrapper-navbar')) {
            setTimeout(() => {
                /** Set NavBar Height */
                if(mainNav.offsetHeight != 0) {
                    setWrapperNavbarHeight()
                }
            }, 300);
        }

        nl_resize_vh()
    }, true);
    /** END Windows resize */
});
